/*
 * @Description: 
 * @Author: Mayer
 * @Date: 2023-08-23 20:33:08
 * @LastEditors: Mayer
 * @LastEditTime: 2023-08-23 21:40:55
 */
import React, { useEffect, useState } from "react";
import "./index.less";

export default function Sunnbirdback(props: any) {
  const [btnshow, setbtnshow] = useState('')
  useEffect(() => {
    // console.log(this._parseQueryString("?" + window.location.href.split("?")[1]).sunnbirdurl || '')
    if (_parseQueryString("?" + window.location.href.split("?")[1]).sunnbirdurl) {
      setbtnshow(_parseQueryString("?" + window.location.href.split("?")[1]).sunnbirdurl || '')
    }
  }, []);
  // 获取用户信息
  function sunnbirdback() {
    window.location.href = btnshow
  }
  //url解析入参
  function _parseQueryString(queryString: any) {
    if (queryString && queryString.startsWith("?")) {
      const result: any = {};
      queryString
        .slice(1)
        .split("&")
        .forEach((item: any) => {
          const keyValueList = item.split("=");
          result[keyValueList[0]] = decodeURIComponent(keyValueList[1]);
        });
      return result;
    } else {
      return {};
    }
  };
  return (
    <div className="sunnbirdback">
      {btnshow ? <div className="backbtn" onClick={sunnbirdback}><img src={require("../../assets/back.png")} alt="" /></div> : ""}
    </div>
  );
}